import { mapGetters } from "vuex";
import event_bus from "../../shared/utils/event_bus";
import api from "../../core/http/axios";
import routes from "../../core/config/api-ontick.routes";
export default {
  data() {
    return {
      button_is_disabled: false,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    async start(data) {
      this.button_is_disabled = true;
      try {
        const account_id = this.getSelectedAccount.account_id;
        const best_id = data.best_data.best_id;
        const best_multiplier = data.selected_multiplier;
        const best_target = data.selected_target;
        const best_direction = data.type.toUpperCase();

        const response = await api.post(routes.CREATE_BEST, {
          account_id,
          best_id,
          best_multiplier: Number(best_multiplier),
          best_target: Number(best_target),
          best_direction,
        });

        // console.log(response.data);

        this.$swal("BEST", "Best criado com sucesso", "success");
        event_bus.$emit("BEST_STARTED");
        this.$emit("start");
      } catch (err) {
        console.error(err);
        this.$swal("Erro", err.data.msg, "error").then(() => {
          this.$emit("reload");
          this.$emit("close");
        });
      } finally {
        this.button_is_disabled = false;
      }
    },
  },
};
